(() => {
  'use strict';
  if (window.NaturaTradeProgramForms) { window.NaturaTradeProgramForms.init(document); return; }
  function init(root) {
    root.querySelectorAll('form[data-trade-request-form]').forEach(form => {
      if (form.dataset.tradeInitialized === 'true') return;
      const body = form.querySelector('[data-trade-request-body]');
      if (!body) return;
      const fields = Array.from(form.querySelectorAll('[data-trade-field]'));
      const buildBody = () => {
        const requestType = form.querySelector('[data-trade-request-type]');
        const lines = [requestType.value];
        fields.forEach(field => {
          const value = field.value.trim() || form.dataset.emptyLabel;
          lines.push(field.dataset.tradeLabel + ': ' + value);
        });
        body.value = lines.join('\n');
      };
      form.addEventListener('input', buildBody);
      form.addEventListener('change', buildBody);
      // Build the body before Shopify's normal submit/captcha handlers. Never fake success or override the destination.
      form.addEventListener('submit', buildBody, true);
      buildBody();
      form.dataset.tradeInitialized = 'true';
    });
  }
  window.NaturaTradeProgramForms = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
